const createRange = () => {
    return {
        count: 0,
        amount: 0
    }
}

export function analyse(rows) {

    // ====================
    // 第一步：店面汇总
    // 公司名称 + 店面名称
    // ====================

    const storeMap = {}

    rows.forEach(row => {

        const companyName =
            String(
                row['公司名称'] || ''
            ).trim()

        const storeName =
            String(
                row['店面名称'] || ''
            ).trim()

        if (
            !companyName ||
            !storeName
        ) {
            return
        }

        const amount =
            parseFloat(
                row['完成业绩']
            ) || 0

        const key =
            companyName +
            '|' +
            storeName

        if (!storeMap[key]) {

            storeMap[key] = {

                companyName: companyName,

                storeName: storeName,

                amount: 0

            }

        }

        storeMap[key].amount += amount

    })

    // ====================
    // 第二步：按公司统计
    // ====================

    const companyMap = {}

    for (const key in storeMap) {

        const store =
            storeMap[key]

        const companyName =
            store.companyName

        const amount =
            Number(
                store.amount.toFixed(2)
            )

        if (!companyMap[companyName]) {

            companyMap[companyName] = {

                companyName: companyName,

                zero: {
                    count: 0,
                    rate: '0%'
                },

                lt1: createRange(),

                r1_5: createRange(),

                r5_10: createRange(),

                r10_20: createRange(),

                r20_50: createRange(),

                r50_100: createRange(),

                gt100: createRange(),

                total: {
                    count: 0,
                    amount: 0
                }

            }

        }

        const company =
            companyMap[companyName]

        company.total.count++
        company.total.amount += amount

        // ====================
        // 区间统计
        // ====================

        if (amount === 0) {

            company.zero.count++

        }
        else if (amount < 10000) {

            company.lt1.count++
            company.lt1.amount += amount

        }
        else if (amount < 50000) {

            company.r1_5.count++
            company.r1_5.amount += amount

        }
        else if (amount < 100000) {

            company.r5_10.count++
            company.r5_10.amount += amount

        }
        else if (amount < 200000) {

            company.r10_20.count++
            company.r10_20.amount += amount

        }
        else if (amount < 500000) {

            company.r20_50.count++
            company.r20_50.amount += amount

        }
        else if (amount < 1000000) {

            company.r50_100.count++
            company.r50_100.amount += amount

        }
        else {

            company.gt100.count++
            company.gt100.amount += amount

        }

    }

    const result = []

    for (const companyName in companyMap) {

        const company =
            companyMap[companyName]

        company.zero.rate =

            company.total.count === 0

                ? '0%'

                : (
                    company.zero.count /
                    company.total.count *
                    100
                ).toFixed(2) + '%'

        company.total.amount =
            Number(
                company.total.amount.toFixed(2)
            )

        const ranges = [

            company.lt1,
            company.r1_5,
            company.r5_10,
            company.r10_20,
            company.r20_50,
            company.r50_100,
            company.gt100

        ]

        ranges.forEach(item => {

            item.amount =
                Number(
                    item.amount.toFixed(2)
                )

        })

        result.push(company)

    }

    // ====================
    // 总计行
    // ====================

    const summary = {

        companyName: '总计',

        zero: {
            count: 0,
            rate: '-'
        },

        lt1: createRange(),

        r1_5: createRange(),

        r5_10: createRange(),

        r10_20: createRange(),

        r20_50: createRange(),

        r50_100: createRange(),

        gt100: createRange(),

        total: {
            count: 0,
            amount: 0
        }

    }

    result.forEach(item => {

        summary.zero.count += item.zero.count

        summary.lt1.count += item.lt1.count
        summary.lt1.amount += item.lt1.amount

        summary.r1_5.count += item.r1_5.count
        summary.r1_5.amount += item.r1_5.amount

        summary.r5_10.count += item.r5_10.count
        summary.r5_10.amount += item.r5_10.amount

        summary.r10_20.count += item.r10_20.count
        summary.r10_20.amount += item.r10_20.amount

        summary.r20_50.count += item.r20_50.count
        summary.r20_50.amount += item.r20_50.amount

        summary.r50_100.count += item.r50_100.count
        summary.r50_100.amount += item.r50_100.amount

        summary.gt100.count += item.gt100.count
        summary.gt100.amount += item.gt100.amount

        summary.total.count += item.total.count
        summary.total.amount += item.total.amount

    })

    summary.total.amount =
        Number(
            summary.total.amount.toFixed(2)
        )

    result.push(summary)

    return result

}